<template>
  <mdc-dialog v-model="isOpen"
              class="protocol-modal"
              :title="'protocol.add_new_protocol' | trans"
              :cancel="'user.cancel' | trans"
              @cancel="cancel">


    <loader v-if="!isLoaded" class="table-loader"></loader>

    <div class="close-cross" @click="cancel()">
      <mdc-icon icon="close"></mdc-icon>
    </div>

    <div class="form-group row" v-if="this.assignList">
      <div class="col-md-12">

        <select-with-pager id="protocol"
                           class="load_more__select aut-dropdown"
                           :selected=selected
                           :label="'title'"
                           :options="assignList"
                           v-on:set-selected="onSetSelected"
                           :loading= loading
                           :isLastPage=isLastPage
                           v-on:next-page="nextPage"
                           v-on:set-search="searchProtocol"
                           :validated=validated
                           :noOptions="'protocol.choose_protocol' | trans"
                           v-bind:getOptionTitle="getOptionTitle"
                           v-bind:isLast="isLast"
                           >

          <template slot="no-options">
            <div @mousedown.stop="">
              {{ 'protocol.choose_protocol' | trans }}
            </div>
          </template>
        </select-with-pager>

        <label class="mdc-floating-label" :class="{ 'mdc-floating-label-error': errors.has('protocol') }">{{ 'protocol.header' | trans }}</label>
        <span class="description-row">{{'bids.start_protocol' | trans }}</span>
      </div>
      <div class="col-md-12">
          <span class="invalid-feedback-label" v-if="errors.has('protocol')">
            <strong>{{ errors.first('protocol') }}</strong>
          </span>
      </div>
    </div>


    <footer class="mdc-dialog__footer mdc-dialog__footer--visible">
      <button type="button" class="mdc-button mdc-dialog__footer__button mdc-dialog__footer__button--cancel" @click="cancel()"> {{'bids.buttons.cancel' | trans}}</button>

      <mdc-button
          v-if="this.assignList.length"
          class="button-primary"
          raised
          :disabled="disabled"
          @click="onSendRequestButtonClick()">
        {{'protocol.buttons.addProtocol' | trans }}
      </mdc-button>

      <mdc-button
          v-else
          class="button-primary"
          raised
          :disabled="disabled"
          :to="{ name: 'protocol-create'}">
        {{'protocol.buttons.create' | trans }}
      </mdc-button>
    </footer>
  </mdc-dialog>


</template>

<script>
  import axios from 'axios';
  import {Validator} from 'vee-validate';
  import forEach from 'lodash/forEach';
  import selectWithPager from '../../../../common/selectWithPager/components/SelectWithPager'
  import Loader from '../../../loader/components/Loader';

  export default {
    name: 'ProtocolModal',
    props: {
      'visible': {
        type: Boolean,
        default() {
          return false;
        },
      },
      'clientId': {
        type: [Number, String],
        default() {
          return null;
        },
      },
    },
    data() {
      return {
        apiUrl: '/protocols/',
        assignList: [],
        selected: null,
        userId: null,
        search: '',
        disabled: true,
        lastId: null,
        perPage:  10,
        page: 1,
        loading: false,
        isLastPage: false,
        validated: {
          validate: 'required',
          on: 'none',
          name: 'title',
          as: "'protocol.header' | trans"
        },
        isLoaded: true
      };
    },
    created() {
      this.getAssignList();
    },
    components: {Loader,selectWithPager},
    methods: {
      onSetSelected: function(selected) {
        this.selected = selected;
        this.disabled = false;
      },

      onSendRequestButtonClick() {
        this.isLoaded = false;
        this.disabled = true;
        this.validate();
      },

      async validate() {
        let result = await this.$validator.validateAll();

        if (result) {
          this.save();
        }
      },

      nextPage: async function(){
        if (!this.isLastPage){
          this.loading = true;
          let response = await axios.get(this.apiUrl + 'users/' + this.clientId + '/assign-list/' + this.perPage + '/' + this.page, {
            search: this.search
          });

          response.data.data.items.forEach((item) => {
            this.assignList.push(item)
          });

          this.loading = false;
          this.lastId = this.assignList[this.assignList.length - 1].id;
          if (response.data.data.lastPage != this.page){
            this.page++;
          } else{
            this.isLastPage = true;
          }
        }
      },

      searchProtocol: async function(search){

        try {
          this.page = 1;

          let response = await axios.get(this.apiUrl + 'users/' + this.clientId + '/assign-list/' + this.perPage + '/' + this.page, {
            params: {
              search: search
            }
          });

          this.assignList = response.data.data.items;
          this.lastId = this.assignList.length > 0 ? this.assignList[this.assignList.length - 1].id : null;
          if (response.data.data.hasMorePages){
            this.page++;
            this.isLastPage = false;
          } else{
            this.isLastPage = true;
          }

        } catch (error) {
          console.dir(error);
        }

      },

      getOptionTitle: function({option}) {
        return option.title;
      },

      isLast: function({option}) {
        return option.id == this.lastId;
      },

      async save() {
        this.disabled = true;
        let isSaved = await axios.post(this.apiUrl + 'assigned/', {
              protocolId: this.selected.id,
              clientId: this.clientId,
            });
        if (isSaved) {
          this.close();
          this.disabled = false;
        } else {
          this.disabled = false;
        }

      },

      getAssignList: async function () {
        try {
          let response = await axios.get(this.apiUrl + 'users/' + this.clientId + '/assign-list/' + this.perPage + '/' + this.page, {
                search: this.search
              });

          this.assignList = response.data.data.items;
          this.lastId = this.assignList[this.assignList.length - 1].id;
          if (response.data.data.hasMorePages){
            this.page++;
          } else{
            this.isLastPage = true;
          }

        } catch (error) {
          console.dir(error);
        }
      },

      reset() {
        Object.assign(this.$data, this.$options.data());
        this.getAssignList();
      },

      close() {
        this.reset();
        this.$emit('close');
      },

      cancel() {
        this.reset();
        this.$emit('cancel');
      },
    },
    computed: {
      isOpen: {
        get() {
          return this.visible;
        },
        set() {
        },
      },
    },
  };
</script>


// WEBPACK FOOTER //
// src/modules/user/client/components/ProtocolModal.vue